import React, { useEffect, useState } from 'react';
import AttendanceStartCard from '../components/AttendanceStartCard';
import { ManualAttendanceQuick } from '../components/ManualAttendancePanel';

export default function OtpGenerate({ user }) {
  const [classes, setClasses] = useState([]);
  const [startClassId, setStartClassId] = useState('');   // 出席受付で選んでいる授業【2026-10-13】

  useEffect(() => {
    const token = localStorage.getItem('token');
    fetch('/api/schedule/classes', { headers: { Authorization: 'Bearer ' + token } })
      .then(r => r.json())
      .then(d => setClasses(d.classes || d.data || []))
      .catch(() => {});
  }, []);

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>出席受付</h1>
        <p>授業を選んで、ビーコンかOTPコードのどちらで出席を取るかを選びます。</p>
      </div>

      <AttendanceStartCard user={user} classes={classes} onClassChange={setStartClassId} />

      {/* 打刻できなかった学生を、その場で先生が記録する【2026-10-13】 */}
      <ManualAttendanceQuick classes={classes} suggestedClassId={startClassId} />

      <div className="card" style={{ background: '#f9fafb' }}>
        <div className="card-header"><h2>2つの取り方の違い</h2></div>
        <table className="data-table">
          <thead>
            <tr><th>　</th><th>ビーコン（BLE）</th><th>OTPコード</th></tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>打刻のしかた</strong></td>
              <td>学生のアプリが教室のビーコンを検知して自動で打刻</td>
              <td>黒板やスクリーンに出した6桁を学生が入力</td>
            </tr>
            <tr>
              <td><strong>教室の外から</strong></td>
              <td>電波が届かないので打てない</td>
              <td><strong>番号を知っていれば打てる</strong></td>
            </tr>
            <tr>
              <td><strong>必要なもの</strong></td>
              <td>教室のビーコンと、教員アカウントへのビーコン割り当て</td>
              <td>なし</td>
            </tr>
            <tr>
              <td><strong>終わり方</strong></td>
              <td>手動で終了、または自動終了（既定90分後）</td>
              <td>有効時間が過ぎると失効。手動で無効化も可</td>
            </tr>
            <tr>
              <td><strong>向いている場面</strong></td>
              <td>ふだんの授業</td>
              <td>ビーコンが無い教室、ビーコンの不調時</td>
            </tr>
          </tbody>
        </table>
        <p style={{ fontSize: '0.85rem', color: '#4b5563', lineHeight: 1.8, marginTop: '0.8rem' }}>
          どちらも遅刻の判定は同じ基準です。授業ごとの遅刻のしきい値は
          「授業スケジュール」で設定します。
          OTPは教員が配るものなので、受付時間の外でも出席として記録します。
        </p>
      </div>
    </div>
  );
}
